const JANUS_ERROR_BASE = 0x0f00;
export const JanusErrorCodes = Object.freeze({
  /**
   * Indicates that Janus Gateway initialization failed
   * __Possible Reasons:__
   * - Janus library not loaded
   * - Invalid Janus server configuration
   * - Network connectivity issues
   */
  JANUS_INIT_FAILURE: JANUS_ERROR_BASE + 0x01,

  /**
   * Indicates that Janus streaming plugin attachment failed
   * __Possible Reasons:__
   * - Janus session not established
   * - Invalid plugin configuration
   * - Server-side plugin issues
   */
  JANUS_PLUGIN_ATTACH_FAILURE: JANUS_ERROR_BASE + 0x02,

  /**
   * Indicates that WebRTC connection failed
   * __Possible Reasons:__
   * - ICE connectivity issues
   * - STUN/TURN server problems
   * - Network firewall blocking WebRTC
   * - Browser WebRTC support issues
   */
  WEBRTC_CONNECTION_FAILURE: JANUS_ERROR_BASE + 0x03,

  /**
   * Indicates that WebRTC connection was hung up
   * __Possible Reasons:__
   * - ICE connectivity failure
   * - Network interruption
   * - Server-side connection termination
   */
  WEBRTC_HANGUP_FAILURE: JANUS_ERROR_BASE + 0x04,

  /**
   * Indicates that the Janus streaming plugin returned an error
   * __Possible Reasons:__
   * - Invalid stream/mountpoint ID
   * - Stream not available
   * - Plugin-specific streaming errors
   */
  JANUS_PLUGIN_ERROR: JANUS_ERROR_BASE + 0x05,
});
